var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2197 0.21967L0.71967 13.7197C0.579018 13.8603 0.5 14.0511 0.5 14.25C0.5 14.4489 0.579018 14.6397 0.71967 14.7803C0.860322 14.921 1.05109 15 1.25 15C1.44891 15 1.63968 14.921 1.78033 14.7803L15.2803 1.28033C15.421 1.13968 15.5 0.948912 15.5 0.75C15.5 0.551088 15.421 0.360322 15.2803 0.21967C15.1397 0.0790177 14.9489 0 14.75 0C14.5511 0 14.3603 0.0790176 14.2197 0.21967Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78033 0.21967C1.63968 0.0790176 1.44891 0 1.25 0C1.05109 0 0.860322 0.0790176 0.71967 0.21967C0.579018 0.360322 0.5 0.551088 0.5 0.75C0.5 0.948912 0.579018 1.13968 0.71967 1.28033L14.2197 14.7803C14.3603 14.921 14.5511 15 14.75 15C14.9489 15 15.1397 14.921 15.2803 14.7803C15.421 14.6397 15.5 14.4489 15.5 14.25C15.5 14.0511 15.421 13.8603 15.2803 13.7197L1.78033 0.21967Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.7f6bca153458b8c20fc32093fbc61591.svg";
export { ForwardRef as ReactComponent };